import * as React from "react";
import { DatePicker, Input, Label } from "uxp/components";
import { IUIPropertyDefinition } from '../common';
import { $L } from '../../../localize';

export function SimpleDateProperty(title: string, props: Date, showCategoryTitle = false): IUIPropertyDefinition<Date> {
    return {
        defaults: props,
        render: (props) => {
            return <div className='wd-prop-item'>
                {!!showCategoryTitle && <div className='wd-prop-item-title'>{title}</div>}
                <div className='wd-prop-item-editor'>
                    <Label>{title}</Label>
                    <DatePicker
                        title={title || $L('widgetdesigner.props.date', 'Date')}
                        date={props.uiProps}
                        onChange={s => props.onChange(s)}
                    />
                </div>
            </div>;
        }
    };
}